import { render, staticRenderFns } from "./PatAppointmentsBPage.vue?vue&type=template&id=42976716"
import script from "./PatAppointmentsBPage.vue?vue&type=script&lang=js"
export * from "./PatAppointmentsBPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports